import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { File } from 'app/models/file';
import { Source } from 'app/models/source.enum';
import { FileType } from 'app/models/file-type.enum';
import { FileIconType } from 'app/models/file-icon-type.enum';
import { DialogHelperService } from 'app/services/dialog-helper.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-asset-data-table-item',
  templateUrl: './asset-data-table-item.component.html',
  styleUrls: ['./asset-data-table-item.component.scss']
})
export class AssetDataTableItemComponent implements OnInit {
  @Input() index: number;
  @Input() file: File;
  @Input() showRowNumber: boolean;
  @Input() showTypeImage: boolean;
  @Input() hideDeleteMessage: boolean;
  @Input() hideDeleteButton: boolean;
  @Input() noEvents: boolean;
  @Output() delete: EventEmitter<File> = new EventEmitter();
  public fileIconType: string;

  constructor(private dialogHelper: DialogHelperService,
    private router: Router,
    private activatedRoute: ActivatedRoute) {
    this.showTypeImage = true;
  }

  ngOnInit() {
    this.fileIconType = `icon-${FileIconType[this.enumRrverse(FileType,
      this.file.contentType || this.file.source)]}`;
  }


  enumRrverse(enumList, value) {
    const keys = Object.keys(enumList).filter(k => typeof enumList[k as any] === 'string');
    const values = keys.filter(k => enumList[k as any] === value);
    return values[0];
  }

  onDelete() {
    event.stopPropagation();
    if (!this.hideDeleteMessage) {
      this.dialogHelper.showConfirm(
        'Are you sure you want to delete',
        this.file.name,
        'DELETE FILE',
        () => this.delete.emit(this.file)
      );
    } else {
      this.delete.emit(this.file);
    }
  }

  goTo() {
    if (!this.noEvents) {
      this.router.navigate(
        ['file', this.file.documentId || this.file.id],
        { relativeTo: this.activatedRoute }
      );
    }
  }
}
